<!-- mock各种b2c消息 -->
<template>
  <div v-if="enabled" class="mock-pad">
    <div class="tit animate__animated animate__headShake animate__infinite">mock message</div>
    <ul>
      <li @click="makeEvent(EVENT.TYPING, {typing: true})">EVENT-手动输入中</li>
      <li @click="sendMsg(IMSDKType.MSG_TEXT)">B2C-文本消息</li>
      <li @click="sendMsg(IMSDKType.MSG_IMAGE)">B2C-图片消息</li>
      <li @click="sendMsg(IMSDKType.MSG_FILE)">B2C-文件消息</li>
      <li @click="sendMsg(IMSDKType.MSG_VOICE)">B2C-语音消息</li>
      <li @click="sendMsg(IMSDKType.MSG_IMAGE_TEXT)">B2C-图文消息</li>
      <li @click="sendMsg('leave_form_msg')">B2C-留言消息</li>
      <li @click="sendMsg(IMSDKType.MSG_QDXML)">B2C-XML消息</li>
      <li @click="sendMsg(IMSDKType.MSG_FEED_BACK)">满意度-类型1</li>
      <li @click="changeKF">B2C-切换客服</li>
      <li @click="navMenu">自助导航-XML</li>
      <li @click="sendRobotMsg('htmlmsg')">机器人消息-htmlmsg</li>
      <li @click="sendRobotMsg('freemsg')">机器人消息-freemsg</li>
      <li @click="sendRobotMsg('batchmsg')">机器人消息-batchmsg</li>
      <li @click="sendRobotMsg('robotform')">机器人消息-form</li>
      <li @click="sendRobotMsg('qlist')">机器人消息-qlist-招商信诺</li>
      <li @click="sendRobotMsg('tablemsg')">机器人消息-table</li>
      <li @click="sendRobotMsg('drawer_group')">机器人消息-抽屉聚合</li>
      <li @click="sendRobotMsg('drawer_nogroup')">机器人消息-抽屉不聚合</li>
      <li @click="sendRobotMsg('bubble_group')">机器人消息-气泡聚合</li>
      <li @click="sendRobotMsg('bubble_nogroup')">机器人消息-气泡不聚合</li>
      <li @click="sendRobotMsg('card')">机器人消息-横滑卡片</li>
      <li @click="sendRobotMsg('node')">机器人消息-物流节点</li>
      <li @click="sendMsg(IMSDKType.MSG_ROBOT_NAV)">机器人导航消息</li>
      <li @click="uploadLongText()">上传长文本</li>
      <li @click="downloadLongText()">下载长文本</li>
      <li @click="sendQDXML()">发送企点结构化XML消息</li>
      <li @click="sendRobotMsg('slide')">机器人导航-横滑卡片</li>
      <li @click="sendCouponXml()">发送电商优惠券消息</li>
      <li @click="sendGraphicNotice()">发送电商图文消息</li>
      <li @click="sendGoodsActive()">发送电商多宫格消息</li>
      <li @click="sendBubble()">发送电商气泡消息</li>
      <li @click="sendMsg(IMSDKType.MSG_THIRD_MSG)">b2c-第三方消息-满意度</li>
      <li @click="sendChangeLang()">切换语言</li>
      <li @click="sendMsg(IMSDKType.MSG_TEXT, null, {msg_control_info: { int32_read_status: 1 }})">b2c-文本消息-已读回执</li>
    </ul>
  </div>
</template>

<script>
import StringUtils from '@/utils/string';
import feedbackType1 from '@/components/MockMsg/mock/feedbackType1';
import { IMSDK, SDKUtils } from '@/imsdk/index.ts';
import { getRobotNavContent } from './data/robot-nav-mock.js';

import { imgTxtXML } from './data/img-txt-xml';
import { navMenuXML, businessMsg } from './data/nav-menu-xml';
import { changeKFXML } from './data/change-kf-xml';
import changeLangGrayMsg from './data/change_lang_msg';
import { drawerList, bubbleList, cardList, nodeList, drawerNoGroupList, bubbleNoGroupList } from './data/robot_model_mock';
import robotTestMsg from './data/robot-test-msg';
import { robotCouponXml, robotGraphicNotice, robotGoodsActive, robotBubble, robotSlide } from './data/robot-goods-nav.js';
const imsdk = IMSDK.create();

export default {
  inject: ['MsgType', 'IMSDKType'],
  props: {
    to: {
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      enabled: false, // 是否启用mock
      EVENT: IMSDK.EVENT,
    };
  },
  mounted() {
    // 仅本地开发启用
    if (process.env.NODE_ENV === 'development') {
      this.enabled = true;
    }
  },
  methods: {
    // 模拟B2C发送各种消息
    sendMsg(type, xml = null, crm) {
      const to = this.to.id;

      const msg = {
        seq: StringUtils.generateUUID(),
        type,
        time: Date.now(),
        status: 0,
        from: to,
      };

      if (type === this.IMSDKType.MSG_TEXT) {
        Object.assign(msg, {
          content: `随机文本${Math.random().toString(36)
            .substring(2)}`,
          crm,
        });
      }

      if (type === this.IMSDKType.MSG_IMAGE) {
        Object.assign(msg, {
          content: 'https://c2cpicdw.qpic.cn/offpic_new/0//2852060752-189792930-E59538E23B28257858A4768105725293/0',
          uuid: msg.seq,
          name: '1-115.jpg',
          size: 144836,
          width: 1080,
          height: 1370,
        });
      }

      if (type === 'leave_form_msg') {
        // 因为改数据类型是通过ajax拉表单配置的，没办法在这里mock
        // mock 可以打开 src/components/MockMsg/index.vue 注释
        Object.assign(msg, {
          content: '',
        });
        this.$Toast({ text: '暂不支持', type: 'error' });
        return false;
      }

      if (type === this.IMSDKType.MSG_FILE) {
        Object.assign(msg, {
          content: 'blob:http://localhost:8080/a1b9bb6c-3210-419d-b46b-862b6546954d',
          uuid: 'blob',
          name: 'test.jpg',
          size: 162356,
          format: 'image/jpeg',
        });
      }

      if (type === this.IMSDKType.MSG_VOICE) {
        Object.assign(msg, {
          content: 'https://bqq.gtimg.com/CDN/source/audio/dida.mp3',
          uuid: msg.seq,
          length: 3,
          size: 3829,
        });
      }

      if (type === this.IMSDKType.MSG_IMAGE_TEXT) {
        this.$Toast({ text: '暂不支持', type: 'error' });
        return false;
      }

      if (type === this.IMSDKType.MSG_QDXML) {
        if (!xml) {
          // eslint-disable-next-line no-param-reassign
          xml = imgTxtXML;
        }

        Object.assign(msg, {
          content: {
            content: xml,
          },
        });
      }

      // 测试机器人导航消息
      if (type === this.IMSDKType.MSG_ROBOT_NAV) {
        // 机器人导航类型  0，按钮型 1，简单文本型 2，基础型 3，多主题型 4，小卡片型 5，组合型 6，多级基础型
        Object.assign(msg, {
          content: {
            content: getRobotNavContent(Date.now() % 7),
          },
        });
      }
      // 满意度
      if (type === this.IMSDKType.MSG_FEED_BACK) {
        Object.assign(msg, {
          content: feedbackType1,
          msgHead: {
            uint64_msg_sync_seq: 111111,
            uint64_side_sync_seg: 222222,
            uint64_msg_roaming_seq: 333333,
            msg_type_info: {
              msg_c2c_info: {
                uint64_from_aid: 4444,
                uint64_to_aid: 5555,
              },
            },
          },
        });
      }

      // 重构满意度(第三方)
      if (type === this.IMSDKType.MSG_THIRD_MSG) {
        Object.assign(msg, {
          content: {
            crmFlag: 60,
            content: 'uk=92D8F3F949001CE76007B9EC1DD0AE30_86400_1670987498',
          },
        });
      }
      this.mackB2CMsg(msg);
    },

    // 模拟B2C消息
    mackB2CMsg(msg) {
      const to = this.to.id;

      const msgList = {
        [to]: [msg],
      };
      console.log('mock', msgList);
      imsdk.emit(IMSDK.EVENT.MESSAGE_RECEIVED, msgList);
    },

    changeKF() {
      this.sendMsg(this.IMSDKType.MSG_QDXML, changeKFXML);
    },

    /**
     * 模拟上屏机器人消息
     */
    sendRobotMsg(subType) {
      const to = this.to.id;

      const msg = {
        seq: StringUtils.generateUUID(),
        type: this.IMSDKType.MSG_ROBOT,
        time: Date.now(),
        status: 0,
        from: to,
        crm: {
          msg_webim_extra_data: { bytes_wpaid: '', uint64_robotid: '' }, str_session_id: '',
        },
      };
      // 机器人消息-htmlmsg
      if (subType === 'htmlmsg') {
        // 消息内容
        msg.content = robotTestMsg.htmlMsg;
      }
      // 机器人消息-freemsg
      if (subType === 'freemsg') {
        const demoData = robotTestMsg.freeMsgList;
        msg.content = demoData[Date.now() % (demoData.length)];
      }
      // 机器人消息-batchmsg
      if (subType === 'batchmsg') {
        msg.content = robotTestMsg.batchMsg;
      }
      // 机器人消息-form
      if (subType === 'robotform') {
        msg.type = this.IMSDKType.MSG_ROBOT_FORM;
        msg.content = robotTestMsg.robotForm;
      }
      // 招商信诺
      if (subType === 'qlist') {
        const demoData = robotTestMsg.qlist;
        msg.content = demoData;
      }
      // 机器人消息-抽屉聚合
      if (subType === 'drawer_group') {
        msg.content = drawerList.data;
      }
      // 机器人消息-气泡聚合
      if (subType === 'bubble_group') {
        msg.content = bubbleList.data;
      }
      // 机器人消息-横滑卡片
      if (subType === 'card') {
        msg.content = cardList.data;
      }
      // 机器人消息-物流节点
      if (subType === 'node') {
        msg.content = nodeList.data;
      }
      // 机器人消息-气泡不聚合
      if (subType === 'drawer_nogroup') {
        msg.content = drawerNoGroupList.data;
      }

      if (subType === 'bubble_nogroup') {
        msg.content = bubbleNoGroupList.data;
      }
      if (subType === 'slide') {
        msg.content = robotSlide;
      }
      if (subType === 'tablemsg') {
        msg.content = {
          type: 17,
          content: '文本内容描述啊，<b>描述</b>描述',
          table: {
            headers: ['姓名', '年龄', '性别'],
            rows: [
              ['张三，张三，张三，sahshgasfafhsdg三四个死贵死贵送达岁的萨法斯蒂芬森返多少的佛挡杀佛第三方啥地方都是疙瘩', 28, '男'],
              ['李四', 35, '女，女，女，女，女，女，女，女，女，女，女，女，女，女，女，'],
              ['王五', 42, '男'],
            ],
          },
        };
      }

      if (subType !== 'robotform' && subType !== 'slide') {
        // 单条消息满意度
        msg.content.vote = {
          active: ['up', 'down', ''][Date.now() % 3],
          id: msg.seq,
          expiredIntervalTime: 86400000,
          robotId: 922223543,
          button: [{ key: 'up' }, { key: 'down' }],
        };
      }


      this.mackB2CMsg(msg);
    },

    /**
     * 模拟消息
     */
    makeEvent(event, options) {
      imsdk.emit(event, options);
    },

    /**
     * 自助导航
     */
    navMenu() {
      this.sendMsg(this.IMSDKType.MSG_QDXML, navMenuXML);
    },

    /**
     *
     */
    async uploadLongText() {
      const longText = navMenuXML;
      const rs = await SDKUtils.uploadLongText(longText);
      console.log('[uploadLongText-result]', rs);
    },

    /**
     * 下载长文本
     */
    async downloadLongText() {
      const url = await SDKUtils.getDownloadUrl({
        path: '8b497251-475a-4d8b-b1d7-1fd7c3ecc259',
      }, IMSDK.OBJTYPES.OBJ_LONGTEXT);
      const rs = await this.$ajax.get(url);
      console.log('[downloadLongText-result]', url, rs.data);
    },

    /**
     * 发送QD结构化消息
     */
    sendQDXML() {
      // 发送存在问题。
      this.$parent.sendQDXMLMessage({
        qdxml: {
          content: businessMsg,
        },
      });
    },
    sendCouponXml() {
      const to = this.to.id;

      const msg = {
        seq: StringUtils.generateUUID(),
        type: this.IMSDKType.MSG_QDXML,
        time: Date.now(),
        status: 0,
        from: to,
      };
      Object.assign(msg, {
        content: {
          content: robotCouponXml,
        },
      });
      this.mackB2CMsg(msg);
    },
    sendGraphicNotice() {
      const to = this.to.id;

      const msg = {
        seq: StringUtils.generateUUID(),
        type: this.IMSDKType.MSG_QDXML,
        time: Date.now(),
        status: 0,
        from: to,
      };
      Object.assign(msg, {
        content: {
          content: robotGraphicNotice,
        },
      });
      this.mackB2CMsg(msg);
    },
    sendGoodsActive() {
      const to = this.to.id;

      const msg = {
        seq: StringUtils.generateUUID(),
        type: this.IMSDKType.MSG_QDXML,
        time: Date.now(),
        status: 0,
        from: to,
      };
      Object.assign(msg, {
        content: {
          content: robotGoodsActive,
        },
      });
      this.mackB2CMsg(msg);
    },
    sendBubble() {
      const to = this.to.id;

      const msg = {
        seq: StringUtils.generateUUID(),
        type: this.IMSDKType.MSG_QDXML,
        time: Date.now(),
        status: 0,
        from: to,
      };
      Object.assign(msg, {
        content: {
          content: robotBubble,
        },
      });
      this.mackB2CMsg(msg);
    },


    sendChangeLang() {
      const to = this.to.id;
      const msg = {
        seq: StringUtils.generateUUID(),
        time: Date.now(),
        status: 0,
        from: to,
        ...changeLangGrayMsg,
      };
      this.mackB2CMsg(msg);
    },
  },
};
</script>

<style lang="less" scoped>
.mock-pad {
  position: fixed;
  top: 100px;
  left: 0;
  border-radius: 0 10px 10px 0;
  background: #18f;
  color: #fff;
  font-size: 14px;
  z-index: 9999;
  width: 40px;
  height: 40px;
  overflow: hidden;
  transition: all 0.3s;

  &:hover {
    width: 200px;
    height: 80vh;
    overflow-y: auto;
  }

  .tit {
    padding: 10px;
    font-weight: 600;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      padding: 14px;
      border-bottom: 1px dashed #ddd;
      cursor: pointer;
      background: rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
